
export const apiUrl = 'https://us-central1-bamako-city-tour.cloudfunctions.net/api';
export const apiV1Url = `${apiUrl}/v1`;
export const apiPublicUrl = `${apiUrl}/public`;
